import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

const Register = () => {
  const { t } = useLang();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const cleanEmail = email.trim().toLowerCase();
      const cleanName = name.trim();
      const result = await register(cleanName, cleanEmail, password);
      if (result?.requires_verification) {
        toast.success(t.auth.verify_email_sent);
        navigate(`/verify-email?email=${encodeURIComponent(cleanEmail)}`);
      } else {
        toast.success("Welcome");
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20" data-testid="register-page">
      <div className="max-w-md mx-auto">
        <span className="overline">Sign up</span>
        <h1 className="font-heading text-5xl mt-4 tracking-tighter text-[#EDE7D8]">{t.auth.register_title}</h1>

        <form onSubmit={submit} className="mt-10 space-y-6 grid-card p-8" data-testid="register-form">
          <div>
            <label className="field-label">{t.auth.name}</label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="field-input"
              data-testid="register-name"
              autoComplete="name"
            />
          </div>
          <div>
            <label className="field-label">{t.auth.email}</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
              data-testid="register-email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="field-label">{t.auth.password}</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
              data-testid="register-password"
              autoComplete="new-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-pill w-full justify-center"
            data-testid="register-submit"
          >
            {loading ? t.common.loading : t.auth.submit_register}
          </button>
        </form>

        <Link
          to="/login"
          className="mt-6 inline-block text-sm text-[#D4AF37] hover:text-[#F1D26B] transition-colors duration-300"
          data-testid="register-switch-login"
        >
          {t.auth.switch_to_login}
        </Link>
      </div>
    </main>
  );
};

export default Register;
